import './cards.css';

//Equipe Principal
import imgAndre from "../../../img/equipe/Andre.jpg";
import imgDiogo from "../../../img/equipe/Diogo.jpg";
import imgLayara from "../../../img/equipe/Layara.jpg";
import imgTatiana from "../../../img/equipe/Tatiana.jpg";

//Equipe Completa
import imgAline from "../../../img/equipe/Aline.jpg";
import imgAndrea from "../../../img/equipe/Andrea.jpg";
import imgCarolyne from "../../../img/equipe/Carolyne.jpg";
import imgCarolineFaria from "../../../img/equipe/Caroline.jpg";
import imgMaeli from "../../../img/equipe/Maeli.jpg";
import imgMilena from "../../../img/equipe/Milena.jpg";
import imgTamires from "../../../img/equipe/Tamires.jpg";
import imgRenata from "../../../img/equipe/Renata.jpg";
import imgMariaLucia from "../../../img/equipe/MariaLucia.jpg";
import imgMariaEduarda from "../../../img/equipe/mariaEduarda.jpg";
import imgSandra from "../../../img/equipe/Sandra.jpg"
import imgThais from "../../../img/equipe/Thais.jpg"
import imgMaira from "../../../img/equipe/Maira.jpg"
import imgLiliane from "../../../img/equipe/Liliane.jpg"
import imgNahyra from "../../../img/equipe/Nahyara.jpg"
import imgTatiane from "../../../img/equipe/Tatiane.jpg"
import imgLeonardo from "../../../img/equipe/Leonardo.jpg"

const Cards = ({ equipeCompleta }) => {
    return (
        <div>
            <div className="row g-4 justify-content-center">
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                    <div className="team-item rounded">
                        <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                            <img src={imgThais} className="img-fluid rounded-top w-100" alt="" />
                            <div className="team-icon d-flex justify-content-center">
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-facebook-f"></i></a>
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-instagram"></i></a>
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                        <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                            <h5>Thais</h5>
                            <p className="mb-0">Téc. Enfermagem</p>
                            <div className="card-rodape rounded-bottom p-2">
                                <p className='card-description'>
                                    Técnica de enfermagem com 4 anos de experiência na UTI Neonatal.
                                    Atua com dedicação, amor e compromisso com o cuidado humanizado, sendo grata a Deus pelo dom de cuidar dos
                                    recém-nascidos.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                    <div className="team-item rounded">
                        <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                            <img src={imgSandra} className="img-fluid rounded-top w-100" alt="" />
                            <div className="team-icon d-flex justify-content-center">
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-facebook-f"></i></a>
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-instagram"></i></a>
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                        <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                            <h5>Sandra</h5>
                            <p className="mb-0">Téc. Enfermagem</p>
                            <div className="card-rodape rounded-bottom p-2">
                                <p className='card-description'>
                                    Com 14 anos de atuação na neonatologia, é grata a Deus pelo privilégio de
                                    cuidar das crianças com amor, carinho e dedicação.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                    <div className="team-item rounded">
                        <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                            <img src={imgMariaLucia} className="img-fluid rounded-top w-100" alt="" />
                            <div className="team-icon d-flex justify-content-center">
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-facebook-f"></i></a>
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-instagram"></i></a>
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                        <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                            <h5>Maria Lucia</h5>
                            <p className="mb-0">Téc. Enfermagem</p>
                            <div className="card-rodape rounded-bottom p-2">
                                <p className='card-description'>
                                    Técnica de enfermagem há 14 anos, sendo 7 deles dedicados à UTI Neonatal.
                                    Vive diariamente o milagre da vida, guiada pela fé, gratidão e amor.
                                    Também é mãe, sua maior bênção e inspiração. Atribui a Deus tudo o que é e faz.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                    <div className="team-item rounded">
                        <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                            <img src={imgTatiane} className="img-fluid rounded-top w-100" alt="" />
                            <div className="team-icon d-flex justify-content-center">
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-facebook-f"></i></a>
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-instagram"></i></a>
                                <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                    className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                        <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                            <h5>Tatiane</h5>
                            <p className="mb-0">Téc. Enfermagem</p>
                            <div className="card-rodape rounded-bottom p-2">
                                <p className='card-description'>
                                    Casada, mãe do Vinicíus e da Mirela, é técnica de enfermagem há 16 anos.
                                    Ao longo dessa trajetória, é grata a Deus por presenciar muitos milagres e por poder ajudar o
                                    próximo com carinho e amor.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {equipeCompleta && (
                <div className="row g-4 justify-content-center mt-0">
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgRenata} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Renata</h5>
                                <p className="mb-0">Téc. Enfermagem</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Com 20 anos e 5 meses de experiência dedicados ao cuidado neonatal,
                                        atua com carinho e compromisso junto aos recém-nascidos.
                                        É mãe do Renan e do Luan, e carinhosamente conhecida como 'Titia Renata' entre colegas e pacientes.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgMilena} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Milena</h5>
                                <p className="mb-0">Téc. Enfermagem</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Com experiência na oncologia pediátrica, desenvolveu habilidades essenciais como cuidado,
                                        resiliência e empatia. Atualmente na UTI Neonatal,
                                        dedica-se ao cuidado ao cuidado dos recém-nascidos com paixão e propósito.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgAndrea} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Andréa Paz</h5>
                                <p className="mb-0">Téc. Enfermagem</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Técnica de enfermagem há 18 anos, sempre se dedicando, com todo amor e
                                        cuidado aos pequenos e grandes guerreiros na uti neonatal. É mãe e filha muito
                                        abençoada por Deus.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgMariaEduarda} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Maria Eduarda</h5>
                                <p className="mb-0">Téc. Enfermagem</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Há mais de um ano atuando na UTI Neonatal, dedicando-se com amor e cuidado.
                                        Busca sempre trabalhar com alegria, harmonia, amor e responsabilidade.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgMaeli} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Maeli</h5>
                                <p className="mb-0">Enfermeira</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Enfermeira especialista em neonatologia há 22 anos, com atuação marcada pelo amor,
                                        dedicação e compromisso com o cuidado integral. Com sólida formação e valores cristãos,
                                        tem a fé como guia em sua trajetória profissional.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgTamires} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Tamires</h5>
                                <p className="mb-0">Enfermeira</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Enfermeira há 13 anos e especialista em Cuidados Intensivos em Neonatologia.
                                        Atua com dedicação, amor e empatia no cuidado aos recém-nascidos.
                                        É esposa e mãe, e acredita que sua missão é guiada por valores de fé e compromisso com a vida.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgMaira} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Maíra</h5>
                                <p className="mb-0">Enfermeira</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Mãe da Lara e da Manuela, encontra nelas sua força diária.
                                        Enfermeira com 10 anos de atuação em neonatologia, dedicada a essa missão com gratidão e compromisso.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgNahyra} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Nahyara</h5>
                                <p className="mb-0">Enfermeira</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Enfermeira com mais de 10 anos de experiência em neonatologia.
                                        Mãe do Miguel, sua força diária. Atua acreditando na força dos pequenos e
                                        transformando cada cuidado em um gesto de amor.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgAline} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Aline Rodrigues</h5>
                                <p className="mb-0">Fisioterapeuta</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Fisioterapeuta com 15 anos de experiência. Esposa e mãe de dois filhos.
                                        Guia sua trajetória profissional e pessoal pela fé, inspirada pelos valores espirituais e pela gratidão.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgCarolyne} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Carolyne Borges</h5>
                                <p className="mb-0">Fisioterapeuta</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Fisioterapeuta especializada em pediatria e UTI neonatal, dedicada ao cuidado dos recém-nascidos com
                                        amor, fé e profissionalismo. Guia sua atuação pelos valores espirituais e
                                        é profundamente grata pela missão que desempenha.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgLiliane} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Liliane</h5>
                                <p className="mb-0">Fisioterapeuta</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Fisioterapeuta respiratória intensivista há 16 anos, dedicada e apaixonada pela profissão.
                                        Esposa e mãe de dois filhos, encontra neles inspiração diária para aprimorar seu trabalho.
                                        Guia sua vida pela fé, sendo protegida por Deus e Nossa Senhora.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100" style={{ maxHeight: 306 }}>
                                <img src={imgCarolineFaria} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom pt-2">
                                <h5>Caroline Faria</h5>
                                <p className="mb-0">Fisioterapeuta</p>
                                <div className="card-rodape rounded-bottom p-2">
                                    <p className='card-description'>
                                        Fisioterapeuta há 7 anos. Gosta de estudar e sempre se atualizar para
                                        oferecer o melhor aos pacientes.
                                        Filha e esposa muito abençoada por Deus.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100">
                                <img src={imgDiogo} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                <h5>Diogo Giotti Morais</h5>
                                <p className="mb-0">Médico - Pediatria e Neonatologia</p>
                                <p className="mb-0">CRM 52222-MG</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.5s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100">
                                <img src={imgLayara} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                <h5>Layara Maria Garcia</h5>
                                <p className="mb-0">Médica - Pediatria e Neonatologia</p>
                                <p className="mb-0">CRM 50306-MG</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100">
                                <img src={imgTatiana} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                <h5>Tatiana Maia Borges Campos</h5>
                                <p className="mb-0">Médica - Pediatria</p>
                                <p className="mb-0">CRM 51505-MG</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100">
                                <img src={imgLeonardo} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                <h5>Leonardo Costa Rodrigues Furtado</h5>
                                <p className="mb-0">Médico</p>
                                <p className="mb-0">CRM 55982</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="team-item rounded">
                            <div className="team-img rounded-top h-100">
                                <img src={imgAndre} className="img-fluid rounded-top w-100" alt="" />
                                <div className="team-icon d-flex justify-content-center">
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-facebook-f"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-instagram"></i></a>
                                    <a className="d-flex btn btn-square btn-primary text-white rounded-circle mx-1"><i
                                        className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                <h5>André Luiz Silva</h5>
                                <p className="mb-0">Médico - Pediatria e Neonatologia</p>
                                <p className="mb-0">CRM 42205</p>
                            </div>
                        </div>
                    </div>

                </div>

            )
            }
        </div>
    )
}

export default Cards;